"use strict";import m from"../src/spectrum-two/scale-medium.css.js";import{Theme as e}from"../src/Theme.js";import"../src/spectrum-two/core.js";e.registerThemeFragment("medium-spectrum-two","scale",m);
//# sourceMappingURL=scale-medium.js.map
